import { Disclosure } from '@headlessui/react';
import React, { useEffect, useState } from 'react'
import { FaChevronUp } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { selectCurrent } from '../../../../redux/settings/selectors';

export const AccordionComponet = ({headerTitle,expandedPanel,child}:any) => {
  const [color, setColor] = useState('universal')
  const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar,theme,primary ,secondary} = result

  useEffect(() => {
		setColor(theme)
		
	

	}, [theme]);
  return (
 <div className=' py-2'>
      <Disclosure defaultOpen >
        {({ open }) => (
          <>
            <Disclosure.Button className={`flex w-full justify-between rounded-lg primary-${color} px-4 py-2 text-left text-lg font-boldsecondary-${secondary} hover:primary-${color} focus:outline-none focus-visible:ring  border`}>
              <span>{headerTitle}</span>
              <FaChevronUp
                className={`${
                  open ? 'rotate-180 transform' : ''
                } h-5 w-5 secondary-${secondary} text-center`}
              />
            </Disclosure.Button >
            <Disclosure.Panel  className="px-4 pb-2 pt-4 text-sm rounded-lg mt-1 border-2 border-skin-ouprimary shadow-lg">
            {child}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      </div>
  )
}
